/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';

export const Backdrop = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: ${({ fullScreen }) => (fullScreen ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ color, opacity }) => Colors.Alpha(color, opacity)};
  z-index: 999999999;
`;
